export enum ServiceKeyDialogResponse {
    ProceedWithoutKey = "PROCEED-WITHOUT-KEY",
    KeyUpdationSuccessfull = "KEY-UPDATION-SUCCESSFULL",
    Cancel = "CANCEL"
}